import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { IProduct } from '../product.interfaces'
import { ProductQuantity, ProductGallery, ProductBackButton } from '..'
import { modalStore } from './../../shared/modal/modal.store'
import './product-details.scss'
import { resizeImage } from './../product.utils'
interface IProps {
  product: IProduct
  productIsAvailable?: boolean
}

const ProductDetailsI = (props: IProps): JSX.Element => {
  const [galleryImages, setGalleryImages] = useState<string[]>([])
  const [productTags, setProductTags] = useState<JSX.Element[]>([])

  // This lifecycle method is used to support legacy tabs as some content in 'product.description' is straight HTML ULs
  // and we need to apply the 'active' class to the content if the tab is clicked
  useEffect(() => {
    addTabEventListeners()

    const { images, tags } = props.product

    setGalleryImages(images.map((image: string) => resizeImage(image, '1350x')))

    if (tags.map((tag) => tag.toLowerCase()).includes('new')) {
      setProductTags([
        ...productTags,
        <span className='tag-new' key='tag-new'>
          New
        </span>
      ])
    }
    return () => {
      removeTabEventListeners()
    }
  }, [props.product])

  const addTabEventListeners = (): void => {
    const legacyTabs = document.querySelectorAll('.tabs li a')
    const legacyTabsContent = document.querySelectorAll('.tabs-content li')
    if (legacyTabs.length > 0 && legacyTabsContent.length > 0) {
      legacyTabs.forEach((tab) => {
        tab.addEventListener('click', (event: any) => changeTab(legacyTabs, legacyTabsContent, event))
      })
    }
  }

  const changeTab = (legacyTabs: NodeListOf<Element>, legacyTabsContent: NodeListOf<Element>, e: any): void => {
    e.preventDefault()
    const thisTab = e.target
    const thisTabId = thisTab.href.split('#')[1]

    legacyTabs.forEach((tab) => {
      tab.classList.remove('active')
    })
    thisTab.classList.add('active')

    legacyTabsContent.forEach((tabContent) => {
      if (tabContent.id === thisTabId) {
        tabContent.classList.add('active')
      } else {
        tabContent.classList.remove('active')
      }
    })
  }

  const removeTabEventListeners = (): void => {
    const legacyTabs = document.querySelectorAll('.tabs li a')
    const legacyTabsContent = document.querySelectorAll('.tabs-content li')
    if (legacyTabs.length > 0 && legacyTabsContent.length > 0) {
      legacyTabs.forEach((tab) => {
        tab.removeEventListener('click', (event: any) => changeTab(legacyTabs, legacyTabsContent, event))
      })
    }
  }
  const { name, price, metafield_category, metafield_preference, metafield_protein, metafield_cuisine } = props.product
  let description = props.product.description
  description += "<p>Produced in a facility that processes eggs, fish, milk, peanuts, sesame, shellfish, soy, tree nuts, and wheat.</p>"

  const baseClass: string = 'product-details'

  return (
    <div className={`${baseClass}`} key='product-details-modal'>
      <div className='container container--compact-mobile'>
        <div className='row'>
          <div className='col col--12of12 col--6of12--md'>
            <div className={`${baseClass}__navigation`}>
              <ProductBackButton onClick={modalStore.toggle} />
            </div>

            <ProductGallery images={galleryImages} overflow='left' />
          </div>
          <div className='col col--12of12 col--6of12--md'>
            <div className={`${baseClass}__information`}>
              {metafield_cuisine && <div className={`${baseClass}__information__cuisine`}>{metafield_cuisine}</div>}
              <h1 className={`${baseClass}__information__title`}>
                <div>{productTags}</div>
                {name}
              </h1>
              <div className={`${baseClass}__information__metafields`}>
                {metafield_protein && <div className='product-tag protein'>{metafield_protein}</div>}
                {metafield_preference.map((preference: string, i: number) => (
                  <div className='product-tag preference' key={i}>
                    {preference}
                  </div>
                ))}
                {metafield_category.map((category: string, i: number) => (
                  <div className='product-tag category' key={i}>
                    {category}
                  </div>
                ))}
              </div>

              <div className={`${baseClass}__information__details`}>
                <div className={`${baseClass}__information__details__item`}>
                  <h5>Price</h5>${price}
                </div>
              </div>

              <h5>Quantity</h5>
              <div className={`${baseClass}__information__details__add-to-cart`}>
                <ProductQuantity productIsAvailable={props.productIsAvailable} {...props.product} />
              </div>
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const ProductDetails = observer(ProductDetailsI)
